import React, { Component } from 'react';
import { format_bytes, format_number, MISSION_COLOR_PALETTE } from '../../utils/data';
import Chart from 'react-apexcharts';
import { v4 } from 'uuid';
import MediaModal from '../MediaModal/MediaModal';

interface Props {
    title: string
    data: any
    size?: boolean
    colors?: Array<string>
    chartData?: { url: string, info: string }
}

export default class CumulativeDataChart extends Component<Props> {

    render = () => {
        // let _data = data.map((d) => { return d.value });
        let _dates = this.props.data[0]?.values?.map((d: any) => { return d.date });

        let series = this.props.data.map((serie: any) => {
            return {
                name: serie.key,
                data: serie.values?.map((value: any) => { return value.value })
            }
        })

        // let color = size ? COLORS.size : COLORS.number ;

        let width = 500;
        let height = 300;

        return (
            <div className="date-slide-chart">
                <div className="chart-title chart-title-cumulative">
                    <div className="chart-title"> {this.props.title}</div>
                    {
                        !!this.props.chartData &&
                        <MediaModal chartData={this.props.chartData} />
                    }
                </div>
                <div className="date-slide-chart-chart">
                    <Chart
                        height={height}
                        width={width}
                        type="area"
                        // series={[{
                        //     name: title,
                        //     data: _data
                        // }]}
                        series={series}
                        // series={data.map((d)=>{ return d.percentage })}
                        options={{
                            colors: this.props.colors || MISSION_COLOR_PALETTE,
                            grid: {
                                padding: {
                                    bottom: 0
                                },
                            },
                            legend: {
                                showForSingleSeries: true,
                            },
                            labels: _dates,
                            chart: {
                                stacked: true,
                                animations: { enabled: false },
                                height: height,
                                toolbar: {
                                    show: false,
                                    autoSelected: 'pan'
                                },
                            },
                            xaxis: {
                                type: 'datetime',
                            },
                            yaxis: {
                                labels: {
                                    formatter: (value) => {
                                        return this.props.size ? `${format_bytes(value, { decimals: 0, base: 1000 })}` : `${format_number(value, 1)}`;
                                    },
                                },
                            },
                            // colors: [ color ],
                            dataLabels: {
                                enabled: false
                            },
                            fill: {
                                opacity: 1,
                                type: 'solid'
                            },
                        }}
                    />
                </div>
            </div>
        )
    }
}